import { useTranslation } from 'react-i18next';

import BellIcon from '@/assets/icons/BellIcon.svg?react';

import styles from './styles.module.css';

interface NotificationBellProps {
  onClick: () => void;
  isUnread: boolean;
}

const NotificationBell = ({ onClick: openNotificationPanel, isUnread }: NotificationBellProps) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      className={styles.bellIcon}
      onClick={openNotificationPanel}
      aria-label={t('notificationCenter.openButtonLabel')}
    >
      <BellIcon />
      {isUnread && <span className={styles.unreadIndicator}></span>}
    </button>
  );
};

export { NotificationBell };
